import { UIGameEventController } from './UIGameEventController.ts';
import { BotsMatchType, ModeSettingEnum } from '@colonist/game-base-types';
import { SocketGameSend } from '../socket/SocketGameSend.ts';
import { notificationController, socket, uiManagerEvents } from '../EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../store/subscription_overlay/subscriptionOverlayABTest.ts';
import { CA } from '../analytics/Analytics.ts';
import { sendRushAdClicked, sendRushAdImpression } from '../analytics/sendRushAdAnalytic.ts';
import { Point, TradeActions } from '@colonist/game-mechanic-validators';
import { UIGameBeginnerModeController } from './ui_game_beginner_mode/UIGameBeginnerModeController.ts';
import { UIGameBeginnerHintsController } from './ui_game_beginner_hints/UIGameBeginnerHintsController.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { ClientUserState } from '../ClientUserState.ts';
import { createGameStore } from '@colonist/ui-game';
import { GameStateEnums, getDiceSettingText, getExtensionSettingText, getScenarioSettingText, PlayerEnums } from '../../../../shared/GameEnums.ts';
import { GameModeDataController } from '@colonist/shared-types';
import { MapDataController } from '../../../../shared/map_data/MapDataController.ts';
import { passThroughTranslation } from '@colonist/i18n';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { ColonistMembershipType, LobbyImage } from '@colonist/types';
import { AnalyticEventCategory, AnalyticEventType, AnalyticEventValue, GiftMembershipMethod } from '../../../../shared/entity_datas/EntityDatas.ts';
import { renderUIGame } from './renderUIGame.tsx';
import { StorageWrapper } from '../StorageWrapper.ts';
import { MobileDeviceUtils } from '../MobileDeviceUtils.ts';
import { getHomepageUrlWithParameter, navigateToPage } from '../ui_utils/ClientUtils.ts';
import { UIUrlParameterNames } from '../ui_html/UIUrlController.ts';
import { UIEntryUrlParameterController } from '../UIEntryUrlParameterController.ts';
import { showEndgameSignupDialog } from '../ui_popup/endgame_signup_dialog/showEndgameSignupDialog.ts';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { showReportPlayerDialog } from '../ui_popup/showReportPlayerDialog.ts';
import { NotificationContentType } from '../ui_utils/NotificationUtils.ts';
import { RulebookPage } from '../../../../shared/enums/RulebookEnums.ts';
import { showRulebookPopup } from '../ui_rulebook/UIRulebookPopupGlobal.ts';
import { robberSkinController } from './UIGameRobberSkinController.ts';
import { UIViewProfilePopup } from '../profile/UIViewProfilePopup.ts';
import { UIUtilsFriends } from '../ui_friends/UIUtilsFriends.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { doActionIfCanGiftMembership } from '../store/StoreUtils.ts';
import { showFullScreenMembershipDialog } from '../ui_popup/showFullScreenMembershipDialog.ts';
import { showRushRulesDialog } from '../ui_popup/showRushRulesDialog.ts';
import { AudioManager } from '@colonist/audio';
import { PIXI } from '@colonist/pixi';
import { UIGameMapBottomLogo } from './ui_game_map/UIGameMapBottomLogo.ts';
import ColonistRushLogo from '@static/images/colonist_rush_banner.png';
import ColonistRushGradient from '@static/images/colonist_rush_background_gradient.png';
import IconDiscord from '@static/images/icon_discord.svg';
import { UIGameLargestArmyController } from './ui_game_players/UIGameLargestArmyController.ts';
import { UIGameLongestRoadController } from './ui_game_players/UIGameLongestRoadController.ts';
import { UIGameCityImprovement } from './ui_game_cities_and_knights/UIGameCityImprovement.ts';
import { UIGameKnightController } from './ui_game_cities_and_knights/UIGameKnightController.ts';
import { UIGameFogTileController } from './ui_game_map/UIGameFogTileController.ts';
import { UIGameInventorHighlightDiceController } from './ui_game_map/UIGameInventorHighlightDiceController.ts';
import { UIGameMapChitController } from './ui_game_map/UIGameMapChitController.ts';
import { UIGameMapCityWallController } from './ui_game_map/UIGameMapCityWallController.ts';
import { UIGameMerchantController } from './ui_game_map/UIGameMapMerchantController.ts';
import { UIGameMapPirateController } from './ui_game_map/UIGameMapPirateController.ts';
import { UIGameMapRobberController } from './ui_game_map/UIGameMapRobberController.ts';
import { UIGameMapShipController } from './ui_game_map/UIGameMapShipController.ts';
const UI_GAME_CONTAINER_ID = 'ui-game';
export class UIGameManager {
    initializeSocket(gameState) {
        this.gameState = gameState;
        this.socketGameSend = new SocketGameSend(socket.controller.sender, ()=>this.gameState.serverId);
    }
    resetGameUIToRebuildOnReconnect() {
        if (!this.canvasController.builtGame()) return;
        const mapLocation = new Point(this.mapController.mapView.left, this.mapController.mapView.top);
        const mapZoom = new Point(this.mapController.mapView.scale.x, this.mapController.mapView.scale.y);
        this.originalMapPosition = {
            location: mapLocation,
            zoom: mapZoom
        };
        this.canvasController.app.stage.removeChildren();
        this.eventController = new UIGameEventController();
    }
    resizeUIGame() {
        const gameContainer = document.getElementById(UI_GAME_CONTAINER_ID);
        const view = this.canvasController.app.view;
        if (gameContainer) {
            gameContainer.style.top = view.getBoundingClientRect().top + 'px';
            gameContainer.style.left = view.style.left;
            gameContainer.style.width = this.canvasController.appW + 'px';
            gameContainer.style.height = this.canvasController.appH + 'px';
        }
    }
    buildGame(configurations) {
        var _ClientUserState_userState, _ClientUserState_userState1;
        var _configurations_isReplay, _ClientUserState_userState_items_hasMembership;
        this.gameStore = createGameStore({
            gameGeneral: {
                initialMyColor: this.gameController.myColor,
                initialTimeLeftInSeconds: this.gameController.timeLeftInCurrentState
            },
            gameState: {
                initialGameState: configurations.gameState
            },
            gameUserStates: {
                initialUserStates: configurations.playerUserStates
            },
            gameVote: {
                onVoteAccept: (voteId)=>{
                    this.socketGameSend.clickedVote(voteId, true);
                },
                onVoteReject: (voteId)=>{
                    this.socketGameSend.clickedVote(voteId, false);
                }
            },
            gameSettings: {
                initialGameSettings: configurations.gameSettings,
                gameInfo: this.buildGameInfoContent(configurations)
            },
            gameMode: {
                initialGameModeData: this.gameState.gameModeData
            },
            gameDetails: {
                matchmakingMatchType: configurations.gameDetails.matchmakingMatchType,
                isRanked: configurations.gameDetails.isRanked,
                isDiscord: configurations.gameDetails.isDiscord,
                playOrder: configurations.playOrder,
                isCanvasFullWidth: this.canvasController.responsiveController.isCanvasFullWidth
            },
            gameUserSettings: this.getGameUserSettings(),
            gameTrade: {
                sendUpdateTradeResponse: (tradeResponse)=>{
                    this.socketGameSend.updateTradeResponse(tradeResponse);
                },
                onClickExecuteTrade: (tradeId, playerColor)=>{
                    this.socketGameSend.executeTrade(tradeId, playerColor);
                },
                onClickCreateTrade: (tradeCreationData)=>{
                    this.socketGameSend.createTrade(tradeCreationData);
                    if (tradeCreationData.counterOfferInResponseToTradeId == undefined) return;
                    this.socketGameSend.updateTradeResponse({
                        id: tradeCreationData.counterOfferInResponseToTradeId,
                        response: TradeActions.CounterOfferCreatedOrCanceled
                    });
                },
                onClickToggleEmbargoAgainstPlayer: (color)=>{
                    this.socketGameSend.toggleEmbargoAgainstPlayer(color);
                },
                sendCancelAction: ()=>{
                    this.socketGameSend.cancelAction();
                }
            },
            gamePause: {
                togglePause: ()=>{
                    this.socketGameSend.togglePause();
                }
            },
            gameReplay: {
                isReplay: (_configurations_isReplay = configurations.isReplay) !== null && _configurations_isReplay !== void 0 ? _configurations_isReplay : false
            },
            gameEnd: {
                isSharingEnabled: this.getIsSharingEnabled(configurations),
                gameEndShareIcon: UIUtilsEjsVariables.isUserOnDiscord ? IconDiscord : undefined,
                gameEndedCallback: ()=>this.showSignupPopupAfterGameEnded()
            },
            gameSendEvent: {
                sendLeaveGame: ()=>{
                    this.socketGameSend.leaveGame();
                },
                sendResignGame: ()=>{
                    this.socketGameSend.resign();
                },
                sendDisableKarma: ()=>{
                    this.socketGameSend.submitChat('/disablekarma');
                },
                sendForceOpenGuideBubble: ()=>{
                    this.eventController.sendEvent(undefined, UIGameEventEnums.BeginnerModeForceOpenGuideBubble);
                },
                sendClickedPassTurn: ()=>{
                    this.socketGameSend.clickedPassTurn();
                },
                sendRequestSpecialBuildPhase: ()=>{
                    this.socketGameSend.requestSpecialBuildPhase();
                },
                sendCancelSpecialBuildPhase: ()=>{
                    this.socketGameSend.cancelSpecialBuildPhase();
                },
                sendCancelAction: ()=>{
                    this.socketGameSend.cancelAction();
                },
                sendMoveShip: ()=>{
                    this.socketGameSend.moveShip();
                },
                sendClearRoadEdgeHighlight: ()=>{
                    this.eventController.sendEvent([], UIGameEventEnums.SetRoadEdgeHighlight);
                },
                sendBuildShip: ()=>{
                    this.socketGameSend.buildShip();
                },
                sendClearCornerHighlight: ()=>{
                    this.eventController.sendEvent([], UIGameEventEnums.SetCornerHighlight);
                },
                sendClearTileHighlight: ()=>{
                    this.eventController.sendEvent([], UIGameEventEnums.SetTileHighlight);
                },
                sendBuildSettlement: ()=>{
                    this.socketGameSend.buildSettlement();
                },
                sendBuildRoad: ()=>{
                    this.socketGameSend.buildRoad();
                },
                sendBuildCityWall: ()=>{
                    this.socketGameSend.buildCityWall();
                },
                sendBuildCity: ()=>{
                    this.socketGameSend.buildCity();
                },
                sendBuyDevCard: ()=>{
                    this.socketGameSend.buyDevCard();
                },
                sendUpgradeKnight: ()=>{
                    this.socketGameSend.upgradeKnight();
                },
                sendPlaceKnight: ()=>{
                    this.socketGameSend.placeKnight();
                },
                sendTakeKnightAction: ()=>{
                    this.socketGameSend.takeKnightAction();
                },
                sendActivateKnight: ()=>{
                    this.socketGameSend.activateKnight();
                },
                sendConfirmCityUpgrade: (cityImprovementType)=>{
                    this.socketGameSend.confirmCityUpgrade(cityImprovementType);
                },
                sendClickedDevelopmentCard: (cardEnum)=>{
                    this.socketGameSend.clickedDevelopmentCard(cardEnum);
                },
                sendRequestActionSwap: (gameAction)=>{
                    this.socketGameSend.requestActionSwap(gameAction);
                },
                sendClickedDice: ()=>{
                    this.socketGameSend.clickedDice();
                },
                sendConfirmUseDevelopmentCard: (popupInformation)=>{
                    this.eventController.sendEvent(popupInformation, UIGameEventEnums.ConfirmUseDevelopmentCard);
                },
                sendDiceNumberAnimationEnd: (diceValue)=>{
                    this.eventController.sendEvent(diceValue, UIGameEventEnums.DiceNumberAnimationEnd);
                },
                sendChatMessage: (message)=>{
                    this.socketGameSend.submitChat(message);
                }
            },
            gameClientConfig: {
                currentUserId: (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.id,
                isBotGame: this.gameController.isBotGame(),
                gameOrientation: this.getGameOrientation(),
                enableRotateDeviceWarning: UIUtilsEjsVariables.isUserOnMobileWebBrowser && !UIUtilsEjsVariables.isUserOnTabletApp,
                shouldHideFullScreenButton: UIUtilsEjsVariables.isUserOnDiscord,
                requestFullScreenPermission: ()=>{
                    var _ClientUserState_userState;
                    if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasMembership()) return true;
                    showFullScreenMembershipDialog();
                    return false;
                },
                shouldShowEndGameAd: this.getShouldShowEndGameAd(configurations),
                shouldExcludeStoreAdContent: (_ClientUserState_userState_items_hasMembership = (_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.items.hasMembership()) !== null && _ClientUserState_userState_items_hasMembership !== void 0 ? _ClientUserState_userState_items_hasMembership : false,
                shouldHideStoreFeatures: UIUtilsEjsVariables.shouldHideStoreOnMobile,
                shouldUseDiscordProxyForLocationFlag: UIUtilsEjsVariables.isUserOnDiscord,
                shouldHideAllSendGiftOption: UIUtilsEjsVariables.isUserOnDiscordMobile,
                canSendGiftAfterGameEnd: !UIUtilsEjsVariables.isUserOnMobileAppOrWeb,
                hideMuteUserOption: UIUtilsEjsVariables.isUserOnDiscordMobile,
                friendUsernames: [],
                safeAreaInsetTop: MobileDeviceUtils.getStatusBarHeight(),
                safeAreaInsetBottom: MobileDeviceUtils.getSafeAreaInsetBottom(),
                onClickGameEndAd: (isRushAd)=>{
                    if (isRushAd) {
                        showRushRulesDialog(()=>navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterBotGame, BotsMatchType.ColonistRush)));
                        return;
                    }
                    if (UIUtilsEjsVariables.isUserOnDiscord) {
                        uiManagerEvents.handleUrlRedirectViaParameters(UIUrlParameterNames.DiscordStore, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE);
                        return;
                    }
                    if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
                    else navigateToPage('/store#membership', true);
                },
                onClickMembershipIcon: ()=>{
                    if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
                    else navigateToPage('/store#membership', true);
                },
                onClickSendGift: (username, shouldOpenSendGiftPageInternally)=>{
                    if (UIUtilsEjsVariables.isUserOnDiscord && shouldOpenSendGiftPageInternally) {
                        doActionIfCanGiftMembership(()=>{
                            uiManagerEvents.handleUrlRedirectViaParameters(UIUrlParameterNames.DiscordGifting, username);
                        }, username);
                    } else {
                        const url = (UIUtilsEjsVariables.isUserOnDiscord ? 'https://colonist.io' : '') + `/store?username=${username}#gift`;
                        doActionIfCanGiftMembership(()=>navigateToPage(url, true), username);
                    }
                },
                onClickAddFriend: (username)=>{
                    showSimpleDialog({
                        title: {
                            key: 'strings:popups.addFriend.title'
                        },
                        body: {
                            key: 'strings:popups.addFriend.body',
                            options: {
                                username: username
                            }
                        },
                        onConfirm: ()=>void UIUtilsFriends.addFriendAction(username),
                        showCancelBtn: true
                    });
                },
                onClickViewProfile: (username)=>{
                    UIViewProfilePopup.init(username);
                },
                onClickReportPlayer: (username, color)=>{
                    showReportPlayerDialog(username, (playerName, reportReason)=>{
                        const databaseGameId = socket.gameListener.databaseGameId;
                        const userReportData = {
                            reason: reportReason,
                            databaseGameId: databaseGameId
                        };
                        void UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiReportPlayer(playerName), undefined, userReportData, 'application/json');
                        this.socketGameSend.reportPlayer(reportReason, color);
                    }, true);
                },
                onToggleMutePlayer: (playerName, isMuted)=>{
                    const notificationKey = isMuted ? 'strings:popups.notification.userMuted' : 'strings:popups.notification.userUnmuted';
                    notificationController.showNotification(LobbyImage.Chat, {
                        key: notificationKey,
                        options: {
                            username: playerName
                        }
                    }, 2000);
                },
                onVolumeChanged: (volumeLevel)=>{
                    const volumeText = {
                        key: 'strings:game.settings.shortcutPopups.volumeLevel',
                        options: {
                            count: volumeLevel
                        }
                    };
                    notificationController.showNotification(LobbyImage.Audio, volumeText, 2500, undefined, undefined, NotificationContentType.Volume);
                },
                onToggledMuteVolume: (isMuted)=>{
                    const mutedText = isMuted ? {
                        key: 'strings:game.settings.shortcutPopups.soundMuted'
                    } : {
                        key: 'strings:game.settings.shortcutPopups.soundUnmuted'
                    };
                    notificationController.showNotification(LobbyImage.Audio, mutedText);
                },
                onShowRulebook: ()=>{
                    const modeSetting = this.gameStore.getState().gameSettings.modeSetting;
                    const rulebookPage = UIGameManager.getRulebookPageForGameMode(modeSetting);
                    showRulebookPopup(rulebookPage);
                },
                robberSkinIcon: robberSkinController.getRobberSkin(),
                goToLeaderboard: ()=>{
                    navigateToPage('/leaderboards', true);
                }
            },
            gameAnalytics: this.getGameAnalytics()
        });
        void this.loadFriendUsernames();
        if (!this.uiGameView) {
            const gameContainerPosition = {
                left: parseFloat(this.canvasController.app.view.style.left),
                width: this.canvasController.appW,
                height: this.canvasController.appH
            };
            this.uiGameView = renderUIGame(UI_GAME_CONTAINER_ID, gameContainerPosition);
            this.resizeUIGame();
        }
        this.uiGameView.render({
            options: {
                initialCanResign: this.gameState.canResign,
                isAfterLiveGame: configurations.isAfterLiveGame,
                isChatEnabled: !UIUtilsEjsVariables.isUserOnDiscordMobile
            },
            gameStore: this.gameStore
        });
    }
    async loadFriendUsernames() {
        const friendsData = await UIUtilsFriends.getFriends(ClientUserState.userState);
        const gamePlayerUsernames = this.gameStore.getState().gameUserStates.userStates.map((userState)=>userState.username);
        const friendUsernames = friendsData.friends.filter((friend)=>gamePlayerUsernames.includes(friend.username)).map((friend)=>friend.username);
        this.gameStore.setState((state)=>({
                gameClientConfig: {
                    ...state.gameClientConfig,
                    friendUsernames: friendUsernames
                }
            }));
    }
    buildOptionalMechanics(gameState) {
        var _gameState_experimentalMechanicState;
        const isBeginnerMode = this.gameController.gameSettings.modeSetting == ModeSettingEnum.BeginnerModeClassic4P;
        const areBeginnerHintsEnabled = !isBeginnerMode && !gameState.mechanicBarbarianInvasionState && !gameState.mechanicPirateState && ((_gameState_experimentalMechanicState = gameState.experimentalMechanicState) === null || _gameState_experimentalMechanicState === void 0 ? void 0 : _gameState_experimentalMechanicState.mechanicTurnColonistRushState) == undefined;
        if (gameState.mechanicSettlementState && gameState.mechanicCityState && gameState.mechanicRoadState && areBeginnerHintsEnabled) this.initBeginnerHintsController();
        if (gameState.mechanicLongestRoadState) {
            new UIGameLongestRoadController(this, gameState.mechanicLongestRoadState);
        }
        if (gameState.mechanicLargestArmyState) {
            new UIGameLargestArmyController(this, gameState.mechanicLargestArmyState, gameState.mechanicDevelopmentCardsState);
        }
        if (gameState.mechanicCityWallState) {
            new UIGameMapCityWallController(this, gameState.mechanicCityWallState);
        }
        if (gameState.mechanicShipState) {
            new UIGameMapShipController(this, gameState.mechanicShipState, gameState.mechanicPirateState);
        }
        if (gameState.mechanicRobberState) {
            new UIGameMapRobberController(this, gameState.mechanicRobberState);
        }
        if (gameState.mechanicPirateState) {
            new UIGameMapPirateController(this, gameState.mechanicPirateState);
        }
        if (gameState.mechanicIslandExplorationState) {
            new UIGameMapChitController(this);
        }
        if (gameState.mapState.fogTileGroupStates) {
            new UIGameFogTileController(this, gameState.mapState.fogTileGroupStates);
        }
        if (gameState.mechanicKnightState) {
            new UIGameKnightController(this, gameState.mechanicKnightState, gameState.mechanicRobberState, gameState.mechanicPirateState);
        }
        if (gameState.mechanicMerchantState) {
            new UIGameMerchantController(this, gameState.mechanicMerchantState);
        }
        if (gameState.mechanicProgressCardsState) {
            new UIGameInventorHighlightDiceController(this);
        }
        if (gameState.mechanicCityImprovementsState) {
            new UIGameCityImprovement(this, gameState.mechanicCityImprovementsState, gameState.mechanicRobberState);
        }
        if (isBeginnerMode) this.initBeginnerMode();
    }
    initBeginnerMode() {
        new UIGameBeginnerModeController(this);
        this.cardController.initBeginnerModeHelper();
    }
    initBeginnerHintsController() {
        if (ClientUserState.userState != undefined && !ClientUserState.userState.isBeginner()) return;
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return;
        new UIGameBeginnerHintsController(this);
    }
    // eslint-disable-next-line class-methods-use-this
    buildGameInfoContent(configurations) {
        const gs = configurations.gameSettings;
        return {
            victoryPointsToWin: passThroughTranslation(String(gs.victoryPointsToWin)),
            cardDiscardLimit: passThroughTranslation(String(gs.cardDiscardLimit)),
            gameSpeed: PlayerEnums.getSpeedSettingText(gs.gameSpeed),
            modeSetting: GameModeDataController.getModeName(gs.modeSetting),
            scenarioSetting: getScenarioSettingText(gs.scenarioSetting),
            mapSetting: MapDataController.getMapName(gs.mapSetting),
            extensionSetting: getExtensionSettingText(gs.extensionSetting),
            diceSetting: getDiceSettingText(gs.diceSetting),
            karmaActive: {
                key: `strings:game.settings.gameInfoTab.karma.options.${gs.karmaActive ? 'Active' : 'Inactive'}`
            },
            hideBankCards: {
                key: `strings:game.settings.gameInfoTab.bankCards.options.${gs.hideBankCards ? 'Hidden' : 'Showing'}`
            },
            friendlyRobber: {
                key: `strings:game.settings.gameInfoTab.friendlyRobber.options.${gs.friendlyRobber ? 'Active' : 'Inactive'}`
            }
        };
    }
    // eslint-disable-next-line class-methods-use-this
    getShouldShowEndGameAd(configurations) {
        var _ClientUserState_userState, _ClientUserState_userState1;
        if (UIUtilsEjsVariables.shouldHideStoreOnMobile) return false;
        if (configurations.isReplay) return false;
        if (configurations.gameSettings.modeSetting == ModeSettingEnum.BeginnerModeClassic4P) return false;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasFoundersPack()) return false;
        const membershipType = (_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.items.membership;
        const hasPremiumOrEliteMembership = membershipType == ColonistMembershipType.PremiumMonthly || membershipType == ColonistMembershipType.PremiumYearly || membershipType == ColonistMembershipType.EliteMonthly || membershipType == ColonistMembershipType.EliteYearly;
        if (hasPremiumOrEliteMembership) return false;
        return true;
    }
    // eslint-disable-next-line class-methods-use-this
    getIsSharingEnabled(configurations) {
        if (configurations.gameSettings.modeSetting == ModeSettingEnum.BeginnerModeClassic4P) return false;
        if (UIUtilsEjsVariables.isUserOnMobile) return false;
        return true;
    }
    // eslint-disable-next-line class-methods-use-this
    showSignupPopupAfterGameEnded() {
        var _ClientUserState_userState, _ClientUserState_userState1;
        if (UIUtilsEjsVariables.isUserOnDiscord) return;
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) return;
        const gameCountMilestones = [
            5,
            10,
            25
        ];
        const postMilestonesInterval = 50;
        var _ClientUserState_userState_totalCompletedGameCount;
        const completedGameCount = ((_ClientUserState_userState_totalCompletedGameCount = (_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.totalCompletedGameCount) !== null && _ClientUserState_userState_totalCompletedGameCount !== void 0 ? _ClientUserState_userState_totalCompletedGameCount : 0) + 1;
        const isHardCodedGameCount = gameCountMilestones.includes(completedGameCount);
        const passedTheHardcodedGameCounts = completedGameCount > Math.max(...gameCountMilestones);
        const hitMilestoneInterval = completedGameCount % postMilestonesInterval == 0;
        const shouldShowSignupPopup = isHardCodedGameCount || passedTheHardcodedGameCounts && hitMilestoneInterval;
        if (!shouldShowSignupPopup) return;
        showEndgameSignupDialog(completedGameCount);
    }
    static getRulebookPageForGameMode(gameMode) {
        switch(gameMode){
            case ModeSettingEnum.Classic56P:
            case ModeSettingEnum.Classic78P:
                return RulebookPage.Classic56P;
            case ModeSettingEnum.Seafarers4P:
            case ModeSettingEnum.Seafarers56P:
                return RulebookPage.Seafarers4P;
            case ModeSettingEnum.CitiesAndKnights4P:
            case ModeSettingEnum.CitiesAndKnights56P:
            case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
            case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
                return RulebookPage.CitiesAndKnights4P;
            case ModeSettingEnum.ColonistRush4P:
                return RulebookPage.ColonistRush4P;
            default:
                return RulebookPage.Classic4P;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    getGameOrientation() {
        const isDiscordMobilePortrait = UIUtilsEjsVariables.isUserOnDiscordMobile && UIUtilsEjsVariables.discordActivityMobileOrientation == 'portrait';
        const isMobileWithPortraitSetting = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && StorageWrapper.isPortraitGamePlayEnabled();
        if (isDiscordMobilePortrait) return 'portrait';
        if (isMobileWithPortraitSetting) return 'portrait';
        return 'landscape';
    }
    getGameUserSettings() {
        const isAntialiasEnabledDefault = window.devicePixelRatio * window.innerWidth <= 2000;
        const resolutionDefault = (()=>{
            const allowedResolutions = [
                0.5,
                1,
                1.5,
                2
            ];
            const rawResolution = UIUtilsEjsVariables.isUserOnDiscord ? 2 : window.devicePixelRatio;
            return allowedResolutions.reduce((prev, curr)=>curr <= rawResolution ? curr : prev, 0.5);
        })();
        var _StorageWrapper_getMasterVolume, _StorageWrapper_getAnimation, _StorageWrapper_getAntialias, _StorageWrapper_getKeyboardShortcuts, _StorageWrapper_getResolution;
        return {
            initialVolume: (_StorageWrapper_getMasterVolume = StorageWrapper.getMasterVolume()) !== null && _StorageWrapper_getMasterVolume !== void 0 ? _StorageWrapper_getMasterVolume : AudioManager.DEFAULT_VOLUME,
            initialIsMuted: StorageWrapper.getIsMuted(),
            initialIsAnimationsEnabled: (_StorageWrapper_getAnimation = StorageWrapper.getAnimation()) !== null && _StorageWrapper_getAnimation !== void 0 ? _StorageWrapper_getAnimation : true,
            initialIsAntialiasEnabled: (_StorageWrapper_getAntialias = StorageWrapper.getAntialias()) !== null && _StorageWrapper_getAntialias !== void 0 ? _StorageWrapper_getAntialias : isAntialiasEnabledDefault,
            initialIsKeyboardShortcutsEnabled: (_StorageWrapper_getKeyboardShortcuts = StorageWrapper.getKeyboardShortcuts()) !== null && _StorageWrapper_getKeyboardShortcuts !== void 0 ? _StorageWrapper_getKeyboardShortcuts : true,
            initialResolution: (_StorageWrapper_getResolution = StorageWrapper.getResolution()) !== null && _StorageWrapper_getResolution !== void 0 ? _StorageWrapper_getResolution : resolutionDefault,
            initialPowerPreference: StorageWrapper.getPowerPreference(),
            setCanvasOptions: (options)=>{
                this.canvasController.updateCanvasSettings(options);
            }
        };
    }
    // eslint-disable-next-line class-methods-use-this
    getGameAnalytics() {
        return {
            sendSettingsOpenedAnalytics: ()=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.InGameSettingsOpened,
                    category: AnalyticEventCategory.Game
                });
            },
            sendSettingsClosedAnalytics: ()=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.InGameSettingsClosed,
                    category: AnalyticEventCategory.Game
                });
            },
            sendSettingsTabClickedAnalytics: (tab)=>{
                const TAB_TO_ANALYTIC_EVENT = {
                    gameInfo: AnalyticEventType.InGameSettingsGameInfoClicked,
                    display: AnalyticEventType.InGameSettingsDisplayClicked,
                    audio: AnalyticEventType.InGameSettingsAudioClicked,
                    controls: AnalyticEventType.InGameSettingsControlsClicked
                };
                const eventType = TAB_TO_ANALYTIC_EVENT[tab];
                if (eventType == undefined) return;
                void CA.sendAnalyticEvent({
                    type: eventType,
                    category: AnalyticEventCategory.Game
                });
            },
            sendSettingsValueChangedAnalytics: (stringValue)=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.InGameSettingsValueChanged,
                    category: AnalyticEventCategory.Game,
                    stringValue: stringValue
                });
            },
            sendRushGameEndTurnAnalytics: (turnNumber)=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.ClickedRushGameEndTurn,
                    category: AnalyticEventCategory.Game,
                    dimensions: {
                        gameId: socket.gameListener.databaseGameId,
                        turnNumber: turnNumber
                    }
                });
            },
            sendGiftMembershipClickAnalytics: ()=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.ABTestClickAnalytics,
                    category: AnalyticEventCategory.GiftMembershipOverlay,
                    floatValue: GiftMembershipMethod.InGame
                });
            },
            sendEndgameAdBoxClickAnalytics: ()=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.ABTestClickAnalytics,
                    category: AnalyticEventCategory.ABTestClickAnalytics,
                    floatValue: AnalyticEventValue.ItemBoxMembershipEndgame
                });
            },
            sendRushAdImpressionAnalytics: (source, variant)=>sendRushAdImpression(source, variant),
            sendRushAdClickAnalytics: (source, variant)=>sendRushAdClicked(source, variant),
            sendWasDiceUnfairAnalytics: (playerColor)=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.EndGameWasDiceUnfair,
                    category: AnalyticEventCategory.Game,
                    dimensions: {
                        playerColor: playerColor,
                        gameId: socket.gameListener.databaseGameId
                    }
                });
            },
            sendMobilePausedGameAnalytics: ()=>{
                if (!UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return;
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.MobileGameUserPausedGame,
                    category: AnalyticEventCategory.MobileAnalytics,
                    dimensions: {
                        gameId: socket.gameListener.databaseGameId
                    }
                });
            },
            sendUserAccessedChatAnalytics: (gameMode)=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.UserAccessedChat,
                    category: AnalyticEventCategory.Game,
                    dimensions: {
                        gameId: socket.gameListener.databaseGameId,
                        gameMode: gameMode
                    }
                });
            },
            sendUserAccessedLogAnalytics: (gameMode)=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.UserAccessedLog,
                    category: AnalyticEventCategory.Game,
                    dimensions: {
                        gameId: socket.gameListener.databaseGameId,
                        gameMode: gameMode
                    }
                });
            },
            sendFullScreenMembershipAnalytics: ()=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.ABTestClickAnalytics,
                    category: AnalyticEventCategory.ABTestClickAnalytics,
                    floatValue: AnalyticEventValue.PopupMembershipIncentiveFullScreen
                });
            },
            sendMobileResumedGameAnalytics: ()=>{
                if (!UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return;
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.MobileGameUserResumedGame,
                    category: AnalyticEventCategory.MobileAnalytics,
                    dimensions: {
                        gameId: socket.gameListener.databaseGameId
                    }
                });
            },
            sendInGameInfoWindowViewedAnalytics: (tabName)=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.InGameInfoWindowViewed,
                    category: AnalyticEventCategory.Game,
                    stringValue: tabName,
                    dimensions: {
                        gameId: socket.gameListener.databaseGameId
                    }
                });
            },
            sendInGameInfoWindowClosedAnalytics: ()=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.InGameInfoWindowClosed,
                    category: AnalyticEventCategory.Game,
                    dimensions: {
                        gameId: socket.gameListener.databaseGameId
                    }
                });
            },
            sendInGameInfoWindowTabChangedAnalytics: (tabName)=>{
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.InGameInfoWindowTabChanged,
                    category: AnalyticEventCategory.Game,
                    stringValue: tabName,
                    dimensions: {
                        gameId: socket.gameListener.databaseGameId
                    }
                });
            }
        };
    }
    addColonistRushBranding() {
        const gradientTexture = PIXI.Texture.from(ColonistRushGradient);
        this.canvasController.setBackgroundSprite(gradientTexture);
        const logoTexture = PIXI.Texture.from(ColonistRushLogo, {
            width: 288,
            height: 97
        });
        new UIGameMapBottomLogo(this.mapController, logoTexture);
    }
    constructor(adController){
        this.eventController = new UIGameEventController();
        this.adController = adController;
    }
}
